import React from "react";
import PropTypes from "prop-types";
import { FormControl, InputLabel, Input, MenuItem, Select } from "material-ui";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({});

const ChooseLanguage = props => {
    const {
        t,
        className,
        learningLanguages,
        language,
        handleSelectLanguageChange
    } = props;

    if (learningLanguages.count() <= 1) {
        return <div />;
    }

    return (
        <div>
            <FormControl className={className}>
                <InputLabel htmlFor="language-post-input">
                    {t("postDialog.Language")}
                </InputLabel>
                <Select
                    value={language}
                    onChange={handleSelectLanguageChange}
                    input={<Input name="language" id="language-post-input" />}>
                    {learningLanguages.map(language => {
                        return (
                            <MenuItem key={language} value={language}>
                                {t("languages.codes." + language)}
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>
        </div>
    );
};

ChooseLanguage.propTypes = {
    t: PropTypes.func.isRequired,
    learningLanguages: PropTypes.object.isRequired,
    language: PropTypes.string.isRequired,
    handleSelectLanguageChange: PropTypes.func.isRequired,
    classes: PropTypes.object,
    className: PropTypes.string
};

export default withStylesAndTranslation(ChooseLanguage, styleSheet);



// WEBPACK FOOTER //
// ./src/components/ChooseLanguage.jsx